import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/Index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import routes from './router';
import './static';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router = {routes} />
  </React.StrictMode>
);

reportWebVitals();